import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'base_numeric_with_square',
    dependencies: [
        'levels_maths/base_numeric_simple',
        'levels_maths/base_numeric_simple_reversed', //FIXME
        'levels_maths/int_squared'
    ]
})


function common (q, params) {
    q.addText('Base' + params.base + '(' + params.x + ') = ?')
    q.answer = parseInt(params.x, params.base)
}


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoice([2, 3, 4, 5, 6, 7, 10], {name: 'base'})
        common(q, {
            base,
            x:    100
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoice([2, 3, 4, 5, 6, 7, 10], {name: 'base'})
        common(q, {
            base,
            x:    101
        })
    }
})



level.addQuestion({
    generator: function (q) {
        let base = random.fairChoice([4, 5, 6, 7, 8], {name: 'base'})
        common(q, {
            base,
            x:    random.fairChoiceInt(102, 103, {name: 'x'})
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoice([2, 3, 4, 5, 6, 7, 8], {name: 'base'})
        common(q, {
            base,
            x:    110
        })
    }
})

level.addQuestion({
    generator: function (q) {
        let base = random.fairChoice([3, 4, 5, 6, 7], {name: 'base'})
        common(q, {
            base,
            x:    120
        })
    }
})

level.addQuestion({
    generator: function (q) {
        let base = random.fairChoice([2, 3, 4, 5, 6, 7], {name: 'base'})
        common(q, {
            base,
            x:    111
        })
    }
})

level.addQuestion({
    generator: function (q) {
        let base = random.fairChoice([3, 4, 5, 6, 7], {name: 'base'})
        common(q, {
            base,
            x:    112
        })
    }
})

level.addQuestion({
    generator: function (q) {
        let base = random.fairChoice([3, 4, 5, 6, 7], {name: 'base'})
        common(q, {
            base,
            x:    121
        })
    }
})




export default level

